import { ActionTree } from 'vuex';
import { ContentState, Mutation_setContentIsLoading } from '../stores/content.store';
import { RootState } from '../store';

export const actions: ActionTree<ContentState, RootState> = {
  async setContentIsLoading({ commit }, payload: boolean) {
    commit(Mutation_setContentIsLoading, payload);
  },
};
